import type { GameScreen } from "./types";
import {
  type SpellingWord,
  pickSpellingWord,
  spellingWordsForDifficulty,
} from "./spellingWords";

export type { SpellingWord };
export { pickSpellingWord, spellingWordsForDifficulty };

export interface ActivityDefinition {
  id: string;
  screen: GameScreen;
  title: string;
  subtitle: string;
  emoji: string;
}

export const ACTIVITIES: ActivityDefinition[] = [
  {
    id: "count-stars",
    screen: "activity-count-stars",
    title: "Count the Stars",
    subtitle: "Tap the right number of stars",
    emoji: "⭐",
  },
  {
    id: "planet-jump",
    screen: "activity-planet-jump",
    title: "Planet Jumps",
    subtitle: "Count planets to the stargate",
    emoji: "🪐",
  },
  {
    id: "spelling",
    screen: "activity-spelling",
    title: "Space Words",
    subtitle: "Spell the space word",
    emoji: "🔤",
  },
  {
    id: "constellation",
    screen: "activity-constellation",
    title: "Constellation Trace",
    subtitle: "Drag lines between the stars",
    emoji: "✨",
  },
  {
    id: "space-puzzle",
    screen: "activity-space-puzzle",
    title: "Space Puzzle",
    subtitle: "Drag pieces to complete the picture",
    emoji: "🧩",
  },
  {
    id: "asteroid-sum",
    screen: "activity-asteroid-sum",
    title: "Asteroid Sum",
    subtitle: "Catch numbers that add up!",
    emoji: "☄️",
  },
];
